import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { flex } from 'src/styles/utils';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

import { colors } from '../../styles/colors';
import {
  getInitialLoadIcons,
  ZeeFont,
  ZeeFontBold,
  ZeeFontMedium
} from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';

export const headerContainer = css`
  ${flex('row', 'space-between', 'center')}
  width: 100%;
  z-index: 101;
  height: 44px;
  ${MQ.MediaSm} {
    height: 48px;
  }
  ${MQ.MediaMd} {
    height: 65px;
    text-align: right;
    padding-bottom: 1px;
  }
`;

export const outlineButton = css`
  background: ${colors.Transparent};
  border: 1px solid ${colors.PrimaryWhiteColor};
  border-radius: 6px;
  color: ${colors.PrimaryWhiteColor};
  padding: 0px 12px;
  height: 34px;
  ${flex()}
  ${ZeeFontBold(12, 35)};
  cursor: pointer;
  box-sizing: content-box;
  &:hover {
    background-color: ${colors.white};
    color: ${colors.PrimaryGreyColor};
    transition: background-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  }
  ${MQ.MediaMd} {
    margin-left: auto;
  }
  ${MQ.MediaLg} {
    text-transform: uppercase;
  }
`;

export const marginRight = css`
  margin-right: 4px;
`;
export const buyPlanOrUpgradeButton = css`
  background-color: ${colors.PurpleBtn};
  border-radius: 4px;
  color: ${colors.white};
  cursor: pointer;
  float: left;
  padding: 9.5px 10px;
  position: relative;
  ${flex('row', 'center', 'center')};
  ${ZeeFontBold(10, 13)};
  cursor: pointer;
  text-transform: uppercase;
  ${MQ.MediaMd} {
    margin-right: 8px;
  }
  &:hover {
    background-color: ${colors.PurpleDark};
    transition: background-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  }
  ${MQ.MediaLg} {
    border: none;
    ${ZeeFontBold(12, 14)};
    border-radius: 6px;
    padding: 11px 12px;
    position: relative;
  }
`;

export const headerMobileStyle = css`
  display: flex;
  order: -1;
  flex-grow: 1;
  margin-left: 10px;
  ${MQ.MediaMd} {
    order: 0;
    flex-grow: 0;
    margin-left: 0px;
  }
`;

export const crownIcon = css`
  font-size: 14px;
  font-weight: 400;
  margin-right: 5px;
  ${flex()};
  ${MQ.MediaLg} {
    font-size: 16px;
    margin-right: 6px;
  }
  ${getInitialLoadIcons(InitialLoadIconsSet.CROWN)};
`;

export const userInfoContainer = css`
  display: flex;
`;
export const userInfo = css`
  ${flex('column', 'center', 'flex-start')};
  color: white;
  cursor: pointer;
  margin-left: 4px;
  ${ZeeFontMedium(14, 18)};
`;
export const headerRightContainer = (hideMenu: boolean) => css`
  ${hideMenu ? 'flex-grow: 1' : ''};
  ${flex('row', 'flex-end')};
  gap: 8px;
  width: 100%;
  ${MQ.MediaMd} {
    gap: 16px;
    width: auto;
  }
`;

export const headerLeftContainer = css`
  max-width: 60%;
  ${flex('row', 'flex-start')};
  gap: 12px;
`;

export const mobileNavBarContainer = css`
  width: 100vw;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  & ::-webkit-scrollbar {
    height: 0 !important;
  }
  ${MQ.MediaLg} {
    height: 0px;
  }
`;

export const headerWrapper = css`
  ${flex('column')};
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 101;
  padding: 0 14px 0;
  ${MQ.MediaSm} {
    padding: 8px 14px;
  }
  ${MQ.MediaMd} {
    padding: 0px 14px 0;
    text-align: right;
  }
  ${MQ.MediaLg} {
    padding: 8px 40px 6px;
  }
`;

export const userProfileBtn = css`
  background: none;
  border: none;
  color: ${colors.white};
  ${getInitialLoadIcons(InitialLoadIconsSet.USER_PROFILE)};
  font-size: 18px;
  height: 36px;
  width: 36px;
  border-radius: 18px;
  cursor: pointer;
  background: ${colors.PrimaryWhiteColorAlpha05};
  &:hover {
    background: ${colors.PrimaryWhiteColorAlpha10};
  }

  position: relative;
  &:hover {
    transition: background-color 0.25s ease-in,
      bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
    &:after {
      ${ZeeFont(11, 16)};
      border-radius: 3px;
      left: 50%;
      content: attr(data-tooltip);
      position: absolute;
      bottom: -21px;
      padding: 0 8px;
      min-width: 60px;
      transform: translateX(-50%);
      background: ${colors.TooltipBg};
    }
  }
`;

export const hamburgerMenuIcon = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.HAMBURGER_MENU)};
  ${flex()};
  color: ${colors.white};
  font-size: 18px;
  border-radius: 16px;
  height: 32px;
  width: 32px;
  background: ${colors.PrimaryWhiteColorAlpha05};
  &:hover {
    background: ${colors.PrimaryWhiteColorAlpha10};
  }
`;

export const hamburgerMenuButton = css`
  background: none;
  border: none;
  margin-right: 2px;
  ${MQ.MediaLg} {
    margin-right: 0px;
  }
  cursor: pointer;
`;

export const headerBgStyle = (
  scrollIntersection: boolean,
  isSubscriptionPage: boolean
) => {
  if (isSubscriptionPage) {
    return css`
      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      background: ${scrollIntersection
        ? colors.AppBgColor
        : colors.Transparent};
    `;
  }
  return css`
    background: ${colors.AppBgColor};
  `;
};

export const navMenuContainer = css`
  margin-bottom: 8px;
  margin-left: 6px;
`;

export const NewSubsHeader = styled.header`
  ${flex('row', 'start')};
  position: fixed;
  width: fit-content;
  gap: 18px;
  top: 0;
  cursor: pointer;
  z-index: 101;
  ${MQ.MediaLg} {
    padding: 16px;
  }
`;
